import { Injectable,Injector } from "@angular/core";
import { BaseEndPointService } from "@app/services/base-service/base-endpoint.service";
import { ValueType } from "@app/common/valuetype";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { AppSettings } from "@app/common/app-setting";
// import { IfObservable } from "rxjs/observable/IfObservable";

@Injectable()
export class ValueTypedEndPoint extends AutharizedEndPointService {
    http1 : HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;
    private readonly _getValueTypeUrl: string = '/api/CommonAppController/GetValueType/';
    private readonly _getMerchantByEntityIdUrl: string = '/api/CommonAppController/GetMerchantByEntityId';
    private readonly _getTerminalListUrl: string = '/api/CommonAppController/GetTerminalList/';
    private readonly _getOutletListUrl: string = '/api/CommonAppController/GetOutlets/';
   
    constructor(http: HttpClient) {
      super(http, 'UserManagement/Roles');
      this.http1 = http;
    }

    getUrl(url: string) {
      return this._baseurl + url;
  }

  getTerminalList(parameter){
      return this.http1.get<ValueType>(this.getUrl(this._getTerminalListUrl) + parameter, this.AddAuthToken());
    }

    getMerchantByEntityId(){
      return this.http1.get<ValueType>(this.getUrl(this._getMerchantByEntityIdUrl) , this.AddAuthToken());
    }
    getValueType(parameter: number){
      // debugger
      return this.http1.get<ValueType>(this.getUrl(this._getValueTypeUrl) + parameter);
    }
    getOutlets(){
      return this.http1.get(this.getUrl(this._getOutletListUrl));
    }

}


// WEBPACK FOOTER //
// ./src/app/services/valueType/valueType-endpoint.service.ts